import Connection from 'services/soroban/connection/connection';
import AmmContract from 'services/soroban/contracts/ammContract';
import { createDefaultLockerPreparationFactory } from 'services/soroban/contracts/lockerPreparation';
import TimelockContract from 'services/soroban/contracts/timelockContract';
import TokenContract from 'services/soroban/contracts/tokenContract';
import WeightedProxyContract from 'services/soroban/contracts/weightedProxyContract';

import * as scValHelpers from './utils/scValHelpers';

export default class SorobanService {
    public connection = new Connection();
    public token = new TokenContract(this.connection);
    public amm = new AmmContract(this.connection, this.token);
    public timelock = new TimelockContract(this.connection);
    public scVal = scValHelpers;
    public weightedProxy = new WeightedProxyContract(this.connection);

    constructor() {
        this.timelock.transactions.configure(createDefaultLockerPreparationFactory());
    }
}
